import React from "react";
import { Typography, Box, Grid, Container } from "@mui/material";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useScrollContext } from "./ScrollContext";

const PageHeader = () => {
  const { gsIndicatorRef, relatedResearchRef } = useScrollContext();

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box className="page-header">
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="flex-start">
          {/* 标题部分 */}
          <Grid item xs={12} md={3.5}>
            <Box className="page-header-title">
              <ShowChartIcon className="icon" />

              <Typography
                component="h1"
                className="page-title"
                sx={{ fontSize: { xs: "1.0rem", sm: "1.2rem" } }}
              >
                经济实时预测
              </Typography>
              <Typography
                component="h1"
                className="sub-title"
                sx={{ fontSize: { xs: "1.0rem", sm: "1.2rem" } }}
              >
                Nowcasting
              </Typography>
            </Box>
          </Grid>

          {/* 指标、更新、研究 */}
          {[
            {
              icon: <DateRangeOutlinedIcon className="icon" />,
              title: "指标和数据",
              sub: "Indicators & Data",
              detail: "全国和区域",
              ref: gsIndicatorRef,
            },
            {
              icon: <EventAvailableOutlinedIcon className="icon" />,
              title: "更新频率",
              sub: "Update Schedule",
              detail: "季度和月度更新",
            },
            {
              icon: <InfoOutlinedIcon className="icon" />,
              title: "相关研究",
              sub: "Further Info",
              detail: "关于 Nowcasting",
              ref: relatedResearchRef,
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={4} md={2.83} key={index}>
              <Box
                className="page-header-box"
                onClick={() => item.ref && scrollToSection(item.ref)}
              >
                {item.icon}
                <Typography className="header-text">{item.title}</Typography>
                <Typography className="sub-header">{item.sub}</Typography>
                <Typography className="details-text">{item.detail}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PageHeader;
